import { getHeader } from "h3";
import { defineServerNegotiator } from "../helpers/defineServerNegotiator.js";
import { langcodes } from "#nuxt-language-negotiation/config";
import { parseAcceptLanguage } from "intl-parse-accept-language";
export default defineServerNegotiator(() => {
  return {
    negotiate(event) {
      const header = getHeader(event, "accept-language");
      if (!header) {
        return;
      }
      const result = parseAcceptLanguage(header);
      return result.find((v) => langcodes.includes(v));
    }
  };
});
